import { FC } from 'react'
import { Spacer, Typography, Flex, Button, Containers } from '@jisr-hr/ds'
import DSIcon from 'components/DSIcon'
import i18n from 'translations/i18n'
import { AuthState, TSlug } from 'redux/authUser/types'

import styles from '../login.module.css'

type TSlugs = AuthState['slugs']

type Props = {
  onSelectSlug: (slug: TSlug) => void
  onClickGoBack: () => void
  slugs: TSlugs
}

const OrganizationSelection: FC<Props> = (props) => {
  const { onSelectSlug, onClickGoBack, slugs } = props

  return (
    <>
      <Flex
        itemsCenter
        style={{ gap: 8, cursor: 'pointer' }}
        onClick={onClickGoBack}
      >
        <DSIcon name="arrow-left" />
        <Typography
          variant="subtitle-1"
          text={i18n.t('back')}
        />
      </Flex>
      <Spacer height={36} />

      <Typography
        text={i18n.t('select_organization')}
        variant="heading"
      />
      <Spacer height={8} />
      <Typography
        text={i18n.t('your_account_is_connected_with_two_distinct_organizations')}
        variant="subtitle-1"
      />
      <Spacer height={20} />
      <Flex
        flexCol
        style={{ gap: 16, maxHeight: 400, overflow: 'auto', paddingInlineEnd: 4 }}
      >
        {slugs.map((slug) => (
          <Containers
            key={slug.id}
            width="100%"
            height="fit-content"
            color="white"
            border
            borderRadius="sm"
          >
            <Flex
              itemsCenter
              justifyBetween
              className={styles.contain}
            >
              <Flex
                style={{ gap: 24 }}
                itemsCenter
              >
                <img
                  src={slug.logo}
                  alt={slug.name_i18n}
                  style={{ width: 37, height: 28, borderRadius: 4 }}
                />
                <Typography
                  variant="body-new/medium"
                  text={slug.name_i18n}
                />
              </Flex>
              <Button
                size="sm"
                onClick={(): void => onSelectSlug(slug)}
              >
                {i18n.t('continue_slug')}
              </Button>
            </Flex>
          </Containers>
        ))}
      </Flex>
    </>
  )
}

export default OrganizationSelection
